var map = {
	"./images/icon_sets/emoji_1.png": "ZcKx",
	"./images/icon_sets/emoji_2.png": "cxah",
	"./images/icon_sets/emoji_3.png": "AGn+",
	"./images/icon_sets/emoji_4.png": "oJKE",
	"./images/icon_sets/emoji_5.png": "vAuV",
	"./images/icon_sets/icons.png": "Ixym",
	"./images/icon_sets/stars_1.png": "R53h",
	"./images/icon_sets/stars_2.png": "bPLr",
	"./images/icon_sets/stars_3.png": "WYwX",
	"./images/icon_sets/stars_4.png": "3y+O",
	"./images/icon_sets/stars_5.png": "KIib",
	"./images/icon_sets/weather_1.png": "XQhK",
	"./images/icon_sets/weather_2.png": "vxZr",
	"./images/icon_sets/weather_3.png": "lN0H",
	"./images/icon_sets/weather_4.png": "Tof4",
	"./images/icon_sets/weather_5.png": "E5+T"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vWd4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*$
// module id = vWd4
// module chunks = 1